import { createContext } from 'react';

import { DEFAULT_LOCALE, TLocale } from '@northladder/utilities';

export const LOCAL_STORAGE_LOCALE_KEY = 'activeLocale';

export interface ILocaleContextValue {
  /**
   * The currently active locale. Maybe passed as a config from the backend as
   * per target country, read from local storage or easily from the route path.
   */
  activeLocale: TLocale;
  /**
   * An array of languages that are available to be switched between. If not
   * provided, all languages in the `languagesConfig` will be available.
   */
  availableLanguages?: TLocale[];
  /**
   * Function that can easily update the locale.
   *
   * @param locale - TLocale - The new locale to be updated to.
   */
  onUpdateLocale: (locale: TLocale) => void;
}

export const LocaleContext = createContext<ILocaleContextValue>({
  activeLocale: DEFAULT_LOCALE,
  onUpdateLocale: (locale: TLocale) => {
    localStorage.setItem(LOCAL_STORAGE_LOCALE_KEY, locale);
  },
});
